'use client';
import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  getVisitationForecast,
  getCurrentHourCrowdLevel,
} from '@/helpers/api/visitation-forecast-api';

interface CrowdLevelContextType {
  crowdLevel: number | null;
}

const CrowdLevelContext = createContext<CrowdLevelContextType>({
  crowdLevel: null,
});

interface CrowdLevelProviderProps {
  businessUnitCode?: string;
  timezone?: string;
  showCrowdIndicator?: boolean;
  children: React.ReactNode;
}

export const CrowdLevelProvider = ({
  businessUnitCode,
  timezone,
  showCrowdIndicator,
  children,
}: CrowdLevelProviderProps) => {
  const [crowdLevel, setCrowdLevel] = useState<number | null>(null);

  useEffect(() => {
    if (!showCrowdIndicator) return;
    if (!businessUnitCode) return;
    const today = new Date().toISOString().split('T')[0];
    getVisitationForecast(businessUnitCode, today).then((forecast) => {
      if (!forecast) return;
      const level = getCurrentHourCrowdLevel(forecast, timezone);
      setCrowdLevel(level);
    });
  }, [businessUnitCode, timezone, showCrowdIndicator]);

  return (
    <CrowdLevelContext.Provider value={{ crowdLevel }}>
      {children}
    </CrowdLevelContext.Provider>
  );
};

export const useCrowdLevel = (): number | null => {
  return useContext(CrowdLevelContext).crowdLevel;
};
